import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaffLauncherPage.css';

const DESTINATIONS = [
  { label: 'Holy Ground Cafe', path: '/cafe' },
  { label: 'St. Barbara Kitchen', path: '/barb' },
  { label: 'St. Noufer Kitchen', path: '/nouf' },
  { label: 'Admin', path: '/admin' },
];

export default function StaffLauncherPage() {
  const navigate = useNavigate();

  return (
    <div className="staff-launcher">
      <div className="staff-launcher-card">
        <img src="/logo.png" alt="" className="staff-launcher-logo" />
        <h1 className="staff-launcher-title">Staff Access</h1>
        <p className="staff-launcher-subtitle">Select a destination. Cafe and Admin ask for a PIN.</p>
        <div className="staff-launcher-buttons">
          {DESTINATIONS.map((dest) => (
            <button
              key={dest.path}
              type="button"
              className="btn btn-primary staff-launcher-btn"
              onClick={() => navigate(dest.path)}
            >
              {dest.label}
            </button>
          ))}
        </div>
        <button
          type="button"
          className="staff-launcher-back"
          onClick={() => navigate('/')}
        >
          Back to menu
        </button>
      </div>
    </div>
  );
}
